"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.number.constructor");
var _secKill = require("@/api/activity/secKill");
var _gradeInfo = require("@/api/basic/gradeInfo");
var _PhoneUserSelect = _interopRequireDefault(require("@/components/PhoneUserSelect"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SecKillOrderPane',
  components: {
    PhoneUserSelect: _PhoneUserSelect.default
  },
  props: {
    activityId: {
      type: Number,
      default: null
    },
    activityTitle: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      searchForm: {
        orderSn: '',
        userId: null,
        dateRange: []
      },
      currentStatus: null,
      tableData: [],
      tableLoading: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      exportLoading: false,
      detailDialogVisible: false,
      currentRow: null,
      refundDialogVisible: false,
      refundLoading: false,
      refundForm: {
        orderId: null,
        orderSn: '',
        maxAmount: 0,
        money: 0
      },
      resPath: process.env.VUE_APP_IMAGE_PATH,
      imgPath: process.env.VUE_APP_IMAGE_PATH,
      activityImgUrl: '',
      vipGradeList: []
    };
  },
  mounted: function mounted() {
    if (this.activityId) {
      this.loadVipGradeList();
      this.loadActivityDetail();
      this.fetchData();
    }
  },
  methods: {
    loadVipGradeList: function () {
      var _loadVipGradeList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100
              });
            case 1:
              response = _context.sent;
              if (response.code === 200 && response.records) {
                this.vipGradeList = response.records.map(function (grade) {
                  return {
                    id: grade.id,
                    name: grade.name
                  };
                });
              }
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('获取会员等级列表失败:', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[0, 2]]);
      }));
      function loadVipGradeList() {
        return _loadVipGradeList.apply(this, arguments);
      }
      return loadVipGradeList;
    }(),
    loadActivityDetail: function () {
      var _loadActivityDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, data, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _secKill.getSecKillDetail)(this.activityId);
            case 1:
              res = _context2.sent;
              data = res && res.data ? res.data : res;
              if (data && data.imgUrl) {
                this.activityImgUrl = data.imgUrl;
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取秒杀活动详情失败:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadActivityDetail() {
        return _loadActivityDetail.apply(this, arguments);
      }
      return loadActivityDetail;
    }(),
    // 与抽奖活动的头像展示保持一致（参考 LotteryRecordPane.vue getAvatarUrl）
    getAvatarUrl: function getAvatarUrl(userpic) {
      if (!userpic) return '';
      if (userpic.startsWith('http://') || userpic.startsWith('https://')) return userpic;
      return this.imgPath + userpic;
    },
    // 兼容三种存储格式：完整URL、旧格式(/images/mall/xxx.jpg)、新格式(xxx.jpg)
    getImageUrl: function getImageUrl(path) {
      if (!path) return '';
      if (path.startsWith('http://') || path.startsWith('https://')) return path;
      var prefix = this.resPath || '';
      if (!prefix) return path;
      var p = prefix.endsWith('/') ? prefix : prefix + '/';
      var v = path.startsWith('/') ? path.slice(1) : path;
      return p + v;
    },
    getUserRankName: function getUserRankName(userRank) {
      var grade = this.vipGradeList.find(function (g) {
        return g.id === userRank;
      });
      return grade ? grade.name : '-';
    },
    getUserRankTagType: function getUserRankTagType(userRank) {
      var tagMap = {
        1: 'info',
        2: '',
        3: 'success',
        4: 'warning',
        5: 'danger'
      };
      return tagMap[userRank] || '';
    },
    handlePhoneUserSelect: function handlePhoneUserSelect() {
      // 选中即触发查询，提升体验
      this.currentPage = 1;
      this.fetchData();
    },
    fetchData: function fetchData() {
      var _this = this;
      if (!this.activityId) return;
      this.tableLoading = true;
      var params = {
        page: this.currentPage,
        limit: this.pageSize,
        activityId: this.activityId,
        orderSn: this.searchForm.orderSn,
        userId: this.searchForm.userId
      };
      if (this.currentStatus !== null) params.payStatus = this.currentStatus;
      if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
        params.startDate = this.searchForm.dateRange[0];
        params.endDate = this.searchForm.dateRange[1];
      }
      (0, _secKill.getSecKillOrderList)(params).then(function (res) {
        _this.tableData = res.records || [];
        _this.total = res.total || 0;
      }).catch(function (err) {
        _this.$message.error('获取订单失败：' + (err.message || ''));
        _this.tableData = [];
        _this.total = 0;
      }).finally(function () {
        _this.tableLoading = false;
      });
    },
    handleStatusChange: function handleStatusChange() {
      this.currentPage = 1;
      this.fetchData();
    },
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchData();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        orderSn: '',
        userId: null,
        dateRange: []
      };
      this.currentStatus = null;
      this.currentPage = 1;
      this.fetchData();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchData();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchData();
    },
    handleView: function handleView(row) {
      this.currentRow = row;
      this.detailDialogVisible = true;
    },
    handleDirectRefund: function handleDirectRefund(row) {
      var target = row || this.currentRow;
      if (!target) return;
      var max = Number(target.totalAmount) || 0;
      this.refundForm = {
        orderId: target.id,
        orderSn: target.orderSn,
        maxAmount: max,
        money: max
      };
      this.detailDialogVisible = false;
      this.refundDialogVisible = true;
    },
    confirmDirectRefund: function confirmDirectRefund() {
      var _this2 = this;
      var _this$refundForm = this.refundForm,
        orderId = _this$refundForm.orderId,
        money = _this$refundForm.money,
        maxAmount = _this$refundForm.maxAmount;
      if (!orderId) {
        this.$message.error('缺少订单ID');
        return;
      }
      if (!money || money <= 0) {
        this.$message.error('退款金额必须大于0');
        return;
      }
      if (money > maxAmount) {
        this.$message.error('退款金额不能大于订单金额');
        return;
      }
      this.$confirm("\u786E\u8BA4\u90E8\u5206\u9000\u6B3E \xA5".concat(Number(money).toFixed(2), "\uFF1F\u6B64\u64CD\u4F5C\u4EC5\u9000\u6B3E\u4E0D\u4F5C\u5E9F\u5238\uFF0C\u9000\u6B3E\u540E\u8BA2\u5355\u4E0D\u53EF\u518D\u9000\u6B3E\u3002"), '二次确认', {
        type: 'warning',
        confirmButtonText: '确认退款',
        cancelButtonText: '取消'
      }).then(function () {
        _this2.refundLoading = true;
        (0, _secKill.directSecKillRefund)({
          orderId: orderId,
          money: money
        }).then(function () {
          _this2.$message.success('退款成功');
          _this2.refundDialogVisible = false;
          _this2.fetchData();
        }).catch(function (err) {
          _this2.$message.error('退款失败：' + (err.message || ''));
        }).finally(function () {
          _this2.refundLoading = false;
        });
      }).catch(function () {});
    },
    handleFullRefund: function handleFullRefund(row) {
      var _this3 = this;
      var target = row || this.currentRow;
      if (!target) return;
      this.$confirm("\u786E\u8BA4\u5BF9\u8BA2\u5355 ".concat(target.orderSn || '', " \u8FDB\u884C\u5168\u989D\u9000\u6B3E\uFF1F\n\u6B64\u64CD\u4F5C\u5C06\u4F5C\u5E9F\u8BE5\u8BA2\u5355\u6240\u6709\u5238\u7801\u5E76\u9000\u8FD8 \xA5").concat(Number(target.totalAmount || 0).toFixed(2), "\uFF0C\u4E0D\u53EF\u64A4\u9500\u3002"), '全额退款确认', {
        type: 'error',
        confirmButtonText: '确认退款',
        cancelButtonText: '取消'
      }).then(function () {
        _this3.refundLoading = true;
        (0, _secKill.fullSecKillRefund)({
          orderId: target.id
        }).then(function () {
          _this3.$message.success('退款成功（已退券+退款）');
          _this3.detailDialogVisible = false;
          _this3.fetchData();
        }).catch(function (err) {
          _this3.$message.error('退款失败：' + (err.message || ''));
        }).finally(function () {
          _this3.refundLoading = false;
        });
      }).catch(function () {});
    },
    handleExport: function () {
      var _handleExport = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var params, response, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              this.exportLoading = true;
              _context3.prev = 1;
              this.$message.info('正在提交导出任务...');
              params = {
                activityId: this.activityId,
                orderSn: this.searchForm.orderSn,
                userId: this.searchForm.userId
              };
              if (this.currentStatus !== null) params.payStatus = this.currentStatus;
              if (this.searchForm.dateRange && this.searchForm.dateRange.length === 2) {
                params.startDate = this.searchForm.dateRange[0];
                params.endDate = this.searchForm.dateRange[1];
              }
              _context3.next = 2;
              return (0, _secKill.exportSecKillOrder)(params);
            case 2:
              response = _context3.sent;
              if (response && response.code === 200) {
                this.$message.success(response.message || '数据导出中，请到导出日志查看下载');
              } else {
                this.$message.warning(response && response.message || '导出失败');
              }
              _context3.next = 4;
              break;
            case 3:
              _context3.prev = 3;
              _t3 = _context3["catch"](1);
              this.$message.error('导出失败：' + (_t3.message || '网络异常'));
            case 4:
              _context3.prev = 4;
              this.exportLoading = false;
              return _context3.finish(4);
            case 5:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 3, 4, 5]]);
      }));
      function handleExport() {
        return _handleExport.apply(this, arguments);
      }
      return handleExport;
    }(),
    formatTime: function formatTime(t) {
      if (!t) return '-';
      var d = new Date(t);
      var pad = function pad(n) {
        return String(n).padStart(2, '0');
      };
      return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()), " ").concat(pad(d.getHours()), ":").concat(pad(d.getMinutes()), ":").concat(pad(d.getSeconds()));
    },
    payStatusText: function payStatusText(s) {
      var map = {
        0: '预支付',
        1: '已支付',
        3: '退款中',
        4: '已退款'
      };
      return map[s] != null ? map[s] : '预支付';
    },
    payStatusTagType: function payStatusTagType(s) {
      var map = {
        0: 'info',
        1: 'success',
        3: 'warning',
        4: 'danger'
      };
      return map[s] || 'info';
    },
    orderStatusText: function orderStatusText(s) {
      var map = {
        0: '未支付',
        1: '预支付',
        2: '已付款',
        3: '确认支付',
        4: '已发放',
        9: '已取消'
      };
      return map[s] != null ? map[s] : '-';
    },
    orderStatusTagType: function orderStatusTagType(s) {
      var map = {
        0: 'info',
        1: 'info',
        2: 'warning',
        3: 'warning',
        4: 'success',
        9: 'danger'
      };
      return map[s] || 'info';
    },
    handleDownloadInvoice: function handleDownloadInvoice(row) {
      var url = row.redPdfUrl || row.pdfUrl;
      if (url) window.open(url, '_blank');
    }
  }
};